import { Userpilot } from 'userpilot'
import { USER_INFO_KEY } from "../constants/common";
import { get } from "lodash";


// Demo tenants use their own GuidedTour - skip all UserPilot calls
const isDemoTenant = () => window.__TENANT_CONFIG__?.demoMode;

export const initUserPilot = (token) => {
  Userpilot.initialize(token);
};

export const identifyUser = (userId, userData) => {
  if (isDemoTenant()) return;
  Userpilot.identify(userId, userData);
};

export const identifyUserByLocalStorage = (userDetailsFromStore) => {
  return new Promise((resolve) => {
    const user = JSON.parse(localStorage.getItem(USER_INFO_KEY) || '{}');
    const userInfo = get(user, 'userInfo');

    if(!userInfo) {
      resolve();
      return;
    }

    identifyUser(
      userInfo.userId,
      {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        name: [userInfo.firstName, userInfo.lastName].filter(Boolean).join(' '),
        email: user.email || '',
        userType: user.userType || '',
        planName: get(userDetailsFromStore, '0.PlanName'),
        planPeriod: get(userDetailsFromStore, '0.period')
      }
    );
    resolve();
  });
}


export const trackEvent = (eventName, properties) => {
  if (isDemoTenant()) return;
  Userpilot.track(eventName, properties);
};

export const trigger = (token) => {
  if (isDemoTenant()) return;
  Userpilot.trigger(token)
}

export const triggerOnboarding = async () => {
  await identifyUserByLocalStorage();
  trigger(process.env.REACT_APP_USERPILOT_ONBOARDING_FLOW_KEY);
}


export const showUserPilotOnboarding = () => {
  localStorage.setItem("showUserPilotOnboarding","true")
}

export const reloadUserPilot = () => {
  if (isDemoTenant()) return;
  Userpilot.reload()
}

export default Userpilot;
